<template>
  <div id="container">
    <van-form @submit="submit">
      <van-field
        v-model="mobile"
        label="您的手机"
        placeholder="请输入手机号"
        maxlength="11"
        :rules="[{ required: true }]"
      />
      <van-field
        v-model="code"
        center
        clearable
        label="短信验证码"
        placeholder="请输入验证码"
        maxlength="6"
        :rules="[{ required: true }]"
      >
        <template #button>
          <van-button size="small" type="primary" native-type="button" @click="sendCode()" :disabled="count_down!=='获取验证码'">{{count_down}}</van-button>
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Api from '@/utils/api'
export default {
  data () {
    return {
      mobile: '',
      code: '',
      count_down: '获取验证码'
    }
  },
  methods: {
    countDown (second) {
      second = second !== undefined ? second : this.count_down
      if (second > 0) {
        second = second - 1
        this.count_down = second
        setTimeout(() => this.countDown(), 1000)
      } else {
        this.count_down = '获取验证码'
      }
    },
    sendCode () {
      if (this.mobile === '') {
        this.$toast.fail('请输入手机号')
        return false
      }
      if (!/^1\d{10}$/.test(this.mobile)) {
        this.$toast.fail('手机格式错误')
        return false
      }

      Api.post('sms.verify/create', {type: 10, mobile: this.mobile}, res => {
        this.$toast.success('短信发送成功')
        this.countDown(60)
      })
    },
    submit () {
      if (this.mobile === '') {
        this.$toast.fail('请输入手机号')
        return false
      }
      if (!/^1\d{10}$/.test(this.mobile)) {
        this.$toast.fail('手机格式错误')
        return false
      }
      this.$dialog.confirm({title: '提示', message: '确认绑定吗？'})
        .then(() => {
          Api.post('cus.user/mobile', {
            mobile: this.mobile,
            code: this.code
          })
        })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/wei/user/Mobile.vue